<ul class="navbar-nav mr-auto">
  <!-- <li class="nav-item"> -->
  <!--   <app-nav-search></app-nav-search> -->
  <!-- </li> -->
</ul>
